var _path, _ellipse, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path4, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfetti = function SvgConfetti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 116,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.398 100.658 30.795-61.37 14.578 16.16 16.217 14.525-61.59 30.685Z",
    fill: "#FFDC40"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.736,
    cy: 4.83,
    rx: 21.736,
    ry: 4.83,
    transform: "scale(1.0018 .9982) rotate(45 -18.626 77.754)",
    fill: "#FF9400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.297 55.952a.501.501 0 0 0 .874-.487l-.874.487Zm-16.09-5.814.111.486-.111-.486Zm-20.094 9.108.223.447-.223-.447Zm37.058-3.78c-1.593-2.842-5.012-4.481-8.368-5.32-3.367-.842-6.837-.919-8.707-.495l.222.973c1.672-.378 4.975-.326 8.242.49 3.277.82 6.351 2.367 7.737 4.838l.874-.487ZM94.096 49.65c-1.16.263-1.956.91-2.576 1.737-.603.805-1.06 1.808-1.528 2.79-.953 1.995-2.032 4.065-4.639 5.302l.431.901c2.947-1.398 4.152-3.763 5.113-5.775.488-1.022.896-1.915 1.426-2.62.514-.685 1.12-1.163 1.995-1.361l-.222-.974Zm-8.743 9.83c-1.313.623-2.382.765-3.306.678-.934-.088-1.753-.413-2.578-.783-1.614-.725-3.324-1.695-5.58-.577l.447.894c1.758-.872 2.999-.18 4.721.593.843.378 1.789.763 2.896.867 1.118.105 2.368-.077 3.831-.772l-.43-.9Zm-11.463-.682c-1.566.775-3.41 2.031-4.847 3.08a71.003 71.003 0 0 0-2.317 1.765l-.14.112-.037.03-.01.008-.002.002h-.001l.317.387.317.387.002-.002.009-.007.035-.029.137-.11c.12-.095.294-.234.514-.405.439-.342 1.056-.814 1.768-1.333 1.43-1.043 3.216-2.256 4.7-2.991l-.445-.894Z",
    fill: "#2097F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.74 8.316a.502.502 0 0 1 .691-.155.498.498 0 0 1 .155.689l-.846-.534Zm1.543 17.614.443.233-.443-.233ZM57.254 42.913l-.375-.33.376.33ZM70.587 8.85c-1.44 2.263-1.971 4.224-2.01 5.935-.037 1.714.42 3.216 1.018 4.563.3.674.634 1.305.958 1.907.321.595.64 1.173.892 1.714.494 1.06.827 2.165.282 3.194l-.886-.466c.303-.572.18-1.27-.304-2.307-.237-.508-.537-1.052-.866-1.663a28.787 28.787 0 0 1-.992-1.975c-.634-1.426-1.145-3.078-1.103-4.99.043-1.915.64-4.05 2.165-6.446l.846.534Zm1.14 17.313c-.555 1.048-1.388 1.647-2.35 2.03-.936.372-2.026.551-3.099.748-2.18.401-4.466.905-6.34 3.093l-.762-.648c2.119-2.474 4.722-3.022 6.92-3.426 1.118-.206 2.088-.367 2.91-.695.797-.317 1.417-.778 1.835-1.568l.886.466Zm-11.789 5.871c-.944 1.103-1.359 2.095-1.514 3.007-.156.921-.053 1.793.092 2.684.285 1.74.782 3.637-.885 5.518l-.751-.66c1.3-1.467.951-2.84.647-4.698-.148-.91-.276-1.918-.09-3.011.187-1.104.688-2.26 1.74-3.488l.761.648Zm-2.307 11.21c-1.159 1.307-2.864 2.747-4.263 3.85a68.151 68.151 0 0 1-2.476 1.86l-.039.028-.01.007-.003.002-.29-.407-.288-.408.003-.002a67.36 67.36 0 0 0 2.482-1.862c1.39-1.097 3.037-2.492 4.133-3.73l.751.661Z",
    fill: "#57E3A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 11.373 79.932)",
    fill: "red"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 -10.242 74.395)",
    fill: "#2097F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 -8.242 102.548)",
    fill: "red"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 -.41 133.116)",
    fill: "#FFD80C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 -16.402 146.985)",
    fill: "#57E3A4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 18.704 103.462)",
    fill: "#2097F6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 -16.694 122.955)",
    fill: "#2097F6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.415,
    cy: 2.415,
    r: 2.415,
    transform: "scale(1.0018 .9982) rotate(45 13.667 132.115)",
    fill: "#57E3A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.663 22.656a.5.5 0 1 0-.13-.99l.13.99Zm-12.896 5.472-.426-.264.426.264Zm0 13.637.412.284-.412-.284Zm-14.542 4.262-.33-.376.33.376Zm-5.988 11.08-.144-.478.144.478Zm33.36-34.946a69.56 69.56 0 0 0-.064-.495h-.002l-.007.002a2.16 2.16 0 0 0-.11.015 32.504 32.504 0 0 0-1.508.263c-.988.196-2.337.508-3.782.968-1.442.46-2.991 1.073-4.373 1.876-1.378.801-2.62 1.81-3.41 3.074l.851.527c.67-1.075 1.762-1.982 3.064-2.738 1.297-.755 2.773-1.341 4.174-1.788a34.278 34.278 0 0 1 5.207-1.205l.02-.003h.005l-.064-.496Zm-13.256 5.703c-1.552 2.487-.69 5.035.029 7.286.744 2.335 1.344 4.37-.016 6.332l.825.567c1.677-2.42.865-4.944.145-7.201-.746-2.341-1.402-4.421-.132-6.457l-.85-.527Zm.013 13.618c-1.515 2.187-3.765 2.305-6.445 2.278-2.601-.027-5.617-.202-8.015 1.892l.66.75c2.055-1.793 4.63-1.672 7.345-1.644 2.638.027 5.432-.043 7.28-2.71l-.825-.566Zm-14.46 4.17c-2.011 1.755-2.345 4.382-2.774 6.501-.222 1.095-.463 2.06-.91 2.833-.434.75-1.067 1.33-2.117 1.643l.288.957c1.311-.393 2.144-1.146 2.697-2.101.538-.93.803-2.04 1.024-3.134.457-2.259.754-4.466 2.453-5.949l-.66-.75Zm-5.801 10.977c-.868.26-2.074.267-3.108.196a19.835 19.835 0 0 1-1.76-.203l-.025-.005h-.007l-.089.49-.088.492h.003l.008.002c.007 0 .017.003.03.005l.11.018a20.856 20.856 0 0 0 1.749.197c1.052.072 2.413.079 3.465-.235l-.288-.957Z",
    fill: "red"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.97,
    cy: 112.102,
    rx: 31.453,
    ry: 3.616,
    fill: "#D6D7F5"
  })));
};
export default SvgConfetti;